import React, { FC, useState, useEffect, useCallback,useMemo } from "react";
import { useParams } from "react-router-dom";
import { useClient } from "ClientContext";
import LodgifyCheckoutIframe from "./iframeLodgify";
import axios from "axios";
import { CLIENT_LISTING_QUOTE_OBJECT } from "data/backEndTypes";
import QuoteDetails from "./components/Quote";
import BookingDetails from "./components/BookingDetails";
import BookingDetailsSkeleton from "./components/skeletons/skeletonBookingDetails";
import { QuoteDetailsSkeleton } from "./components/skeletons/QuoteDetailsSkeleton";
import { useFetchQuote } from "hooks/useFetchQuote";
import { useCheckout } from "context/CheckoutContext";


export interface CheckOutPagePageMainProps {
  className?: string;
}

const CheckOutPagePageMain: FC<CheckOutPagePageMainProps> = ({
  className = "",
}) => {
  const { integration_TYPE, clientName, actions,internal_ID,global_language } = useClient();
  const {
    arrival,
    departure,
    listingID,
    currency,
    guests,
    internalId,
    couponCode,
    roomId /// only for lodgify PLACEHOLDER for now 
  } = useParams();
  const guestsCount = guests ? parseInt(guests) : 1;
  const { context_quote, setContext_Quote, listing, setListing, selectedAddons } = useCheckout();
  const [providerId, setProviderID] = useState<string>("");
  const [pageLoading, setPageLoading] = useState<boolean>(false);
  const [error, setError] = useState("");

  const fetchListingDetails = useCallback(async () => {
    if (
      !arrival ||
      !departure ||
      !internalId ||
      !listingID ||
      (integration_TYPE !== "guesty" && integration_TYPE !== "hostaway")
    )
      return;
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/api/controller`,
        {
          action: actions.fetchListingPaymentPage,
          internal_ID: internalId,
          params: {
            listingId: listingID,
          },
        }
      );
      const { data } = response;

      if (integration_TYPE === "guesty") {
        setProviderID(data.item.paymentProvider._id || "");
      };
      setListing(data.item || {});
    } catch (err) {
      setError("Error fetching listing data");
      console.error(err);
    }
  }, [arrival, departure, internalId, listingID]);

  const { quote, handleFetchQuote } = useFetchQuote();

  // Fetch quote and listing details once on mount
  useEffect(() => {
    setPageLoading(true);
    Promise.all([
      handleFetchQuote({
        listingId: listingID,
        couponCode: couponCode,
        addons: (selectedAddons.addons || []).map((addon) => ({
          id: addon.id,
          title: addon.title,
          amount: addon.amount,
          type: addon.type || "",
          amountType: addon.amountType || "",

        })),
      }),
      fetchListingDetails(),
    ]).finally(() => setPageLoading(false));
  }, [listingID, selectedAddons]);

  // Update the global context only when quote is available
  useEffect(() => {
    if (quote) {
      setContext_Quote(quote as CLIENT_LISTING_QUOTE_OBJECT);
    }
  }, [quote, setContext_Quote]);

  const MAIN_IMG =
    listing?.galleryImgs[0]?.thumbnail ||
    listing?.galleryImgs[0]?.original ||
    "";



  if (integration_TYPE === "lodgify") {
    return (
      <div className="mt-0">
        <LodgifyCheckoutIframe
          clientName={clientName}
          checkIn={arrival || ""}
          checkOut={departure || ""}
          guestsNum={guests || ""}
          currency={currency || ""}
          listingId={listingID || ""}
        />
      </div>
    );
  }

  // Render skeletons if page is still loading or quote is not available
  if (!quote || pageLoading || !listing) {
    return (
      <div className={`nc-CheckOutPagePageMain ${className}`}>
        <main className="container mt-11 mb-24 lg:mb-32">
          <div className="flex flex-col lg:flex-row-reverse lg:space-x-6 lg:space-y-0">
            <QuoteDetailsSkeleton />
            <BookingDetailsSkeleton />
          </div>
        </main>
      </div>
    );
  }


  return (
    <div className={`nc-CheckOutPagePageMain ${className}`}>
      <main className="container mt-11 mb-24 lg:mb-32">
        {/* Responsive layout with QuoteDetails on the right for large screens */}
        <div className="flex flex-col lg:flex-row-reverse lg:space-x-6 lg:space-y-0">
          {/* Quote Details Section */}
          <div className="lg:w-1/2 flex-grow mb-4 lg:mb-0 lg:ml-6">
            <QuoteDetails
              clientName={clientName}
              IMG={MAIN_IMG}
              TITLE={listing?.title || ""}
              ADDRESS={listing?.address || {}}
            />
          </div>
          {/* Date Selector and Payment Processing Section */}
          <BookingDetails
            Quote={quote}
            providerId={providerId}
            listingID={listingID || ""}
          />
        </div>
      </main>
    </div>
  );
};

export default CheckOutPagePageMain;
